import { render, staticRenderFns } from "./RiskRatingForm.vue?vue&type=template&id=613143af&"
import script from "./RiskRatingForm.vue?vue&type=script&lang=js&"
export * from "./RiskRatingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports